export default __webpack_public_path__ + "static/media/img-0367-ovato-nation-full-face.0c5e0975.png";